import React from 'react';
import moment from 'moment-timezone';
import Tooltip from 'rc-tooltip';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { getViceVersaFullName, formatMoney } from '../../../../utilities/string';
import { abbrDateYear } from '../../../../utilities/dateTime';

export const nameSort = (a, b) => getViceVersaFullName(a.job.user).localeCompare(getViceVersaFullName(b.job.user));
export const hmSort = (a, b) => (getViceVersaFullName(a.job.hm) || '').localeCompare(getViceVersaFullName(b.job.hm) || '');
export const periodSort = (a, b) =>
    parseInt(moment.tz(b.period_ending || b.created_at, b.job.work_timezone).format('YYYYMMDD'), 10) -
    parseInt(moment.tz(a.period_ending || a.created_at, a.job.work_timezone).format('YYYYMMDD'), 10);

export const clientSort = (a, b, clientsMap) =>
    (a.job.client_id ? clientsMap[a.job.client_id] || '' : '').localeCompare(b.job.client_id ? clientsMap[b.job.client_id] || '' : '');

export const sortNamePeriodAsc = (a, b) => nameSort(a, b) || periodSort(a, b);
export const sortNamePeriodDsc = (a, b) => nameSort(b, a) || periodSort(a, b);

export const sortPeriodNameAsc = (a, b) => periodSort(a, b) || nameSort(a, b);
export const sortPeriodNameDsc = (a, b) => periodSort(b, a) || nameSort(a, b);

export const sortMinutes = (a, b) => (a.minutes || 0) - (b.minutes || 0);
export const sortOtherCount = (a, b) => a.deliverable_count + a.expense_count - (b.deliverable_count + b.expense_count);

export function renderHours(action, minutes, expenseTotal, deliverableTotal) {
    const minuteHours = minutes => (isNaN(minutes) ? <FormattedMessage {...messages.notProvided} /> : (minutes / 60).toFixed(2));
    const moneyTotal = (expenseTotal || 0) + (deliverableTotal || 0);

    const renderHoursOneLine = (action, minutes) => (
        <div className="full-height-cell ellipsis clickable" onClick={action}>
            {minuteHours(minutes)}
        </div>
    );

    const renderHoursTwoLine = (action, minutes, expenseTotal, deliverableTotal) => (
        <div className="col-xs-12 clickable" onClick={action}>
            <div className="row">
                <div className="col-xs-12 ellipsis right-zero">{minuteHours(minutes)}</div>
                <div className="col-xs-12 ellipsis right-zero expenses">+ {formatMoney(moneyTotal)}</div>
            </div>
        </div>
    );

    return expenseTotal || deliverableTotal ? renderHoursTwoLine(action, minutes, expenseTotal, deliverableTotal) : renderHoursOneLine(action, minutes);
}

export function renderPeriodEnding(action, timesheet, job) {
    let isConfirmed =
        timesheet.worker_confirmed_at &&
        moment.tz(timesheet.worker_confirmed_at, job.job_timezone) >= moment.tz(timesheet.last_shift_updated_at, job.job_timezone);

    return (
        <div className="row name-column clickable" onClick={action}>
            <Tooltip
                trigger={'hover'}
                overlay={<FormattedMessage {...(isConfirmed ? messages.confirmed : messages.notConfirmed)} />}
                overlayClassName={'help-button-tooltip'}
            >
                <div className={`col-xs-1 ${isConfirmed ? 'confirmed-timesheet' : 'not-confirmed-timesheet'}`}>
                    <i className="material-icons">{isConfirmed ? 'check' : 'close'}</i>
                </div>
            </Tooltip>
            <div className="period-cell">{abbrDateYear(moment.tz(timesheet.period_ending || timesheet.created_at, job.work_timezone))}</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/timekeeping/lists/timesheets/_common.jsx